export default {
  title: 'Domínio da loja',
  description:
    'Publique as lojas online dos seus restaurantes num domínio próprio em vez do endereço partilhado — por exemplo pizza-mario.encomendas-suamarca.pt. Adiciona dois registos DNS uma única vez; cada restaurante que adicionar depois recebe o seu endereço automaticamente.',
  read_only_description:
    'O domínio onde são publicadas as lojas dos restaurantes deste parceiro. Só o parceiro o pode ligar ou alterar.',
  read_only_empty: 'Este parceiro não ligou nenhum domínio de loja.',
  not_connected: {
    label: 'Domínio para as lojas dos seus restaurantes',
    hint: 'Um domínio ou subdomínio que lhe pertença, por exemplo encomendas-suamarca.pt. Tem de ser um domínio diferente daquele onde funcionam as apps da sua equipa — não um subdomínio dele.',
    placeholder: 'encomendas-suamarca.pt',
    connect: 'Ligar',
  },
  status: {
    pending_dns: 'A aguardar DNS',
    active: 'Ativo',
    failed: 'Ação necessária',
    disabled: 'Desassociado',
  },
  primary_badge: 'Principal',
  summary: {
    pending: 'Estamos a aguardar os seus registos DNS. Normalmente demora alguns minutos e pode demorar algumas horas.',
    failed:
      'Não conseguimos confirmar todos os registos a tempo. Corrija o registo assinalado abaixo e clique em Verificar novamente — a partir daí voltamos a verificar.',
    failed_leave: 'Para ligar um domínio diferente, desassocie primeiro este.',
    live: '{{host}} está ativo.',
    primary: 'Cada novo restaurante recebe automaticamente o seu endereço neste domínio.',
    standby:
      'Defina-o como principal para que cada novo restaurante o receba automaticamente. Os restaurantes que já estão noutro domínio permanecem onde estão.',
    regressed:
      '{{host}} está ativo, mas um registo abaixo deixou de ser confirmado. As suas lojas continuam online — corrija o registo no seu fornecedor de DNS.',
  },
  instructions: {
    title: 'Como adicionar os registos',
    step_provider: 'Inicie sessão onde o DNS de {{root}} é gerido — normalmente a empresa onde comprou o domínio.',
    step_add: 'Adicione cada registo abaixo exatamente como indicado: o tipo, o nome e o valor.',
    step_check: 'Guarde e clique em «{{button}}». Também continuamos a verificar por nossa conta.',
    tip_name:
      'A maioria dos fornecedores só quer a parte antes de {{root}} no campo do nome — _foodamigos-verify e *. O nome completo aparece por baixo, para os fornecedores que o pedem.',
    tip_wildcard:
      'O registo * envia todos os endereços em {{root}} para as suas lojas, por isso nunca tem de adicionar um registo por restaurante.',
    tip_existing:
      'Os registos que já existem para {{root}}, como os do seu site, do e-mail ou de www, continuam a funcionar: o registo * só responde a nomes que não têm um registo próprio. Se {{root}} já tiver um registo *, substitua-o pelo nosso.',
    tip_cloudflare:
      'Na Cloudflare, defina o registo CNAME como «Apenas DNS» (nuvem cinzenta), caso contrário não o conseguimos ver.',
  },
  records: {
    title: 'Adicione estes registos DNS para {{root}} no seu fornecedor de domínio',
  },
  example: 'Um restaurante ficará então num endereço como {{host}}.',
  example_label: 'o-seu-restaurante',
  buttons: {
    check_again: 'Verificar novamente',
    make_primary: 'Tornar principal',
    unlink: 'Desassociar',
    retry: 'Tentar novamente',
  },
  primary_unavailable: 'Disponível quando o domínio estiver ativo.',
  unlink_blocked_one: '{{count}} restaurante ainda está neste domínio. Mova-o para outro domínio antes de desassociar.',
  unlink_blocked_other:
    '{{count}} restaurantes ainda estão neste domínio. Mova-os para outro domínio antes de desassociar.',
  unlink_confirm: {
    title: 'Desassociar {{host}}?',
    description: 'Pode voltar a ligar {{host}} mais tarde.',
    description_primary:
      'Os novos restaurantes voltam a receber um endereço no domínio partilhado. Pode voltar a ligar {{host}} mais tarde.',
    ok: 'Desassociar',
  },
  toasts: {
    load_error: 'Não foi possível carregar o seu domínio de loja',
    load_error_read_only: 'Não foi possível carregar o domínio de loja deste parceiro',
    connected: 'Domínio ligado — adicione agora os registos abaixo',
    connect_failed: 'Não foi possível ligar o domínio',
    check_started: 'A verificar novamente…',
    check_failed: 'Não foi possível iniciar a verificação. Tente novamente dentro de um minuto.',
    primary_set: 'Os novos restaurantes recebem agora este domínio',
    primary_failed: 'Não foi possível tornar este domínio principal',
    unlinked: 'Domínio desassociado',
    unlink_failed: 'Não foi possível desassociar o domínio',
    unlink_has_restaurants_one:
      '{{count}} restaurante ainda está em {{host}}: {{names}}. Mova-o para outro domínio antes de desassociar.',
    unlink_has_restaurants_other:
      '{{count}} restaurantes ainda estão em {{host}}: {{names}}. Mova-os para outro domínio antes de desassociar.',
    gone: '{{host}} já não está ligado — pode ter sido desassociado noutro separador.',
  },
};
